import { useContext, useEffect, useState } from "react";
import MPageHeader from "../../../../component/PageHeader";
import { SpinContext } from "../../../../component/Spin/spin.context";
import { spinActions } from "../../../../component/Spin/spin.reducer";
import { RouteContext } from "../../user/screen/components/route.context";
import { categoryService } from "../service/category.service";
import CategoryTable from "./component/CategoryTable";
import { Category, CategoryUI } from "../entity/category.model";
import { useNavigate } from "react-router";
import helper from "../../../../helper/helper";

export default function Categories() {
  const { dispatch } = useContext(SpinContext);
  const { state } = useContext(RouteContext);
  const [categories, setCategories] = useState<CategoryUI[]>([]);
  const navigate = useNavigate();

  const pageChange = () => {
    dispatch({ type: spinActions.BLOCK });
    categoryService
      .getCategories()
      .then((_brands: CategoryUI[]) => {
        _brands.map((item, index) => {
          helper.getImage("public" + "/" + item.imagePath).then((file) => {
            _brands[index].file = file;
          });
        });
        setCategories(_brands);
        console.log(_brands, "_brands");
        dispatch({ type: spinActions.UNBLOCK });
      })
      .catch(() => {
        dispatch({ type: spinActions.UNBLOCK });
      });
  };

  useEffect(() => {
    pageChange();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.routeId]);

  return (
    <>
      <MPageHeader crumbs={["Төрөл"]} />
      <div className="content">
        <div className="card">
          <div className="card-header header-elements-inline">
            <h6 className="card-title">Төрлүүд</h6>

            <div className="header-elements">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => navigate("/category/add")}
              >
                <i className="icon-plus2 pr-1"></i>
                Төрөл нэмэх
              </button>
            </div>
          </div>
          <div className="card-body">
            <CategoryTable
              data={categories}
              onReload={() => {
                pageChange();
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}
